/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

/*
// Lib imports
import Vuex from 'vuex'

// Store functionality
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state
})

export default store
*/


/* eslint-disable no-console */
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import state from './state'
import createPersistedState from "vuex-persistedstate";


Vue.use(Vuex);

const store = new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state,
  plugins: [createPersistedState({
    key: 'store',
    secure: false
  })]

});

export default store;

export const getDefaultState = () => {
  return {
    profile: {},
    api: {
      token: null
    },
    product: {},
    version: {}
  };
};
